import { common } from './common';
import { userpath } from './userpath';

export const ar = {
  common,
  userpath,
};
